import React, { useContext, useEffect, useState } from 'react';
import stripeOptions from '../../services/stripe'
import { Link } from 'react-router-dom';
import {  Row, Col } from 'react-flexbox-grid';
import { Card, Form, Icon, Image, Message, Divider, Loader, Button, Modal, List } from 'semantic-ui-react';
import { connect } from 'react-redux';
import Logo from '../../images/logo-admin.png';
import { Text, Translate, LanguageContext } from '../../helpers/language';
import { NotificationManager } from 'react-notifications';
import { backendService } from '../../services/backendService';
import { logout, getProducts } from '../../actions/actionCreators';
import  ProfileDeletionConfirmDialog from '../User/ProfileDeletionConfirmDialog';
import SubscriptionItem from './RegistrationSubscriptionItem';
import CardForm from './CardForm.js'
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { elapsed, computeTrialDays, DEFAULT_PLAN_NICKNAME, DEFAULT_TRIAL_DAYS } from './../../services/defaults'


const RegistrationIntegrationPanel = (props) => {  

  const languageContext = useContext(LanguageContext);
  const product_type = 'lisia_standard';
  const price_type = props.auth.user.price_type ? props.auth.user.price_type : 'regular';
  const is_returning = props.auth.user.is_returning ? props.auth.user.is_returning : false;
  const trial_days = computeTrialDays(props.auth.user.trial_expires_at) + DEFAULT_TRIAL_DAYS;

  const [deletionConfirmOpen, setDeletionConfirmDialogOpen] = useState(false);
  const [data_loaded, setDataLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [available_prices, setAvailablePrices] = useState([]);
  const [loading_prices, setLoadingPrices] = useState(true);
  const [product_id, setProductId] = useState(null);
  const [product, setProduct] = useState(null);  
  const [desired_plan_id, setDesiredPlanId] = useState(props.auth.user.desired_plan_id ? props.auth.user.desired_plan_id : null);
  const [selected_plan_id, setSelectedPlanId] = useState(props.auth.user.desired_plan_id ? props.auth.user.desired_plan_id : null);
  const [desired_plan, setDesiredPlan] = useState(null);
  const stripePromise = loadStripe(stripeOptions.api_key);

  const do_logout = () => {
    window.dataLayer.push({
      event: 'user_event',
      eventProps: {
        category: 'user_action',
        action: 'logout',
        label: 'User Logout',
        value: 'true'
    }
    });
    props.dispatch(logout()) ;
  }

  useEffect(() => {  
    if (!data_loaded) {  
      window.dataLayer.push({
        event: 'page_view',
        page: {
          url: document.location.pathname,
          title: 'Registration Integation Visit'
        }
      }); 
      loadData(); 
      setDataLoaded(true);
    } 
    if (selected_plan_id && selected_plan_id !== desired_plan_id) {
      if (desired_plan_id !== selected_plan_id) {
        setDesiredPlanId(selected_plan_id); 
        getDesiredPlanFromAvailablePlans(selected_plan_id);         
      }
    } 
    
  }, [selected_plan_id] );

  const loadData = async () => {
    console.log('Loading data...')
    setLoading(true);
    let prices = await getAvailableProducts();
    if (prices) {
      let selected = prices.find( (cur) =>  {
        return cur.nickname === DEFAULT_PLAN_NICKNAME
      })
      if (selected) {
        let desiredId = selected.id
        setDesiredPlanId(desiredId)
        setSelectedPlanId(desiredId)
        setDesiredPlan(selected);        
      }
    } 
    setLoading(false);
  }

  const openDeletionConfirmDialog = () => {
    setDeletionConfirmDialogOpen(true);
  }

  const closeDeletionConfirmDialog = () => {
    setDeletionConfirmDialogOpen(false);
  }

  const getAvailableProducts =  async () => {
    setLoadingPrices(true);
    try {      
      let response = await backendService.get('/api/stripe/products')
      if (response && response.data && response.data.data) {        
        const products = response.data.data
        let productInfo = null     
        let productId = null   
        products.forEach( item => {
            if (item.metadata.type === product_type && item.active === true) {
              productInfo = item
              productId = item.id
            }
        });
        await setProductId(productId);
        await setProduct(productInfo);
        let prices = await getPrices(productId);
        setLoadingPrices(false);
        return prices;
      }
    } catch(exc) {
      setLoadingPrices(false);
      console.error(exc);
      NotificationManager.error(Translate(languageContext, 'plans_load_failed'))
    }
  }

  /**
   * list available prices
   * @param {*} productId 
   */
  const getPrices = async (productId) => {
    try {
      const response = await backendService.get(`/api/stripe/prices?limit=100&product=${productId}`);      
      let availablePrices = [];          
      if (response.data) {        
        const prices = response.data.data;        
        for (let i = 0; i < prices.length; ++i) {
          const item = prices[i]       
          if ( item.unit_amount !== null && item.active === true && 
              item.metadata.price_type && item.metadata.price_type === price_type) { 
            
            let coupon_id = item.metadata.coupon;
            if(coupon_id) {
              try {
                const couponResp = await backendService.get(`/api/stripe/coupons/${coupon_id}`);
                if (couponResp && couponResp.data) {
                  if (!couponResp.data.redeem_by || (((couponResp.data.redeem_by*1000) - new Date().getTime()) >= 0))
                    item.coupon = couponResp.data
                }
              } catch (exc) {
                console.error('Could not download coupon: ' + exc);
              }
            }    
            //compute amount
            item.amount = item.unit_amount
            availablePrices.push(item);
          } else if (!item.unit_amount && item.recurring && item.active === true && 
                      item.metadata.price_type && item.metadata.price_type === price_type) {
            const priceResponse = await backendService.get(`/api/stripe/plans/${item.id}`);
            if (priceResponse && priceResponse.data) {              
              const newItem = priceResponse.data            
              //has coupon? 
              let coupon_id = item.metadata.coupon;
              if(coupon_id) {
                try {
                  const couponResp = await backendService.get(`/api/stripe/coupons/${coupon_id}`);
                  if (couponResp && couponResp.data)
                    if (!couponResp.data.redeem_by || (((couponResp.data.redeem_by*1000) - new Date().getTime()) >= 0))
                        newItem.coupon = couponResp.data
                } catch (exc) {
                  console.error('Could not download coupon: ' + exc)
                }
              } 
              newItem.amount = newItem.tiers && newItem.tiers[0] ? newItem.tiers[0].flat_amount : 0
              availablePrices.push(newItem)
              
            }
          }
        }   
        availablePrices.sort(function(a, b) { return a.amount - b.amount })   
        await setAvailablePrices(availablePrices);
        return availablePrices;
      }  
    }
    catch (error) {
      console.error(error)
      NotificationManager.error(Translate(languageContext, 'plans_load_failed'))
      await setAvailablePrices([]);      
    }
  }

  /**
   * get desired plan
   * @param {*} planId 
   */
   const getDesiredPlanFromAvailablePlans = async (planId) => {
    try {      
      const found = available_prices.find( item => item.id === planId )
      if (found) {
        setDesiredPlan(found);   
      } else {
        setDesiredPlan(null);
      }
    }
    catch (error) {
      console.error(error)
      NotificationManager.error(Translate(languageContext, 'plans_load_failed'));
    }
  }

  const handleSelectedPlanChange = (value) => {    
    setSelectedPlanId(value);
  }


  return (
    <div className="registration lisia-dialog lisia-registration-dialog">
      <Row center="xs">
        <Col className='registration-confirm-wrapper' xs={11} sm={6} md={4}>
          <Card fluid={true} raised={true} centered={true}>
            <Card.Content>              
              <div className="registrationForm">
                <Image size='small' src={ Logo } className='m-b-10'/>
                { loading ? 
                  <>
                    <h1 className='text-center'><Text tid='loading' />...</h1>  
                    <Loader className='registration-form-loader' active={loading} inline size='large' />
                    <Divider />
                  </>
                  :
                  <> 
                    { is_returning || trial_days === 0 ? 
                      <h1 className='text-center'>{props.auth.user.name}, <Text tid='signup_integration_panel_title' /></h1>         
                    :
                      <h1 className='text-center'>{props.auth.user.name}, { Translate(languageContext, 'signup_integration_panel_title_2').replace(/\${days}/, trial_days) }</h1>                        
                    }
                    <Divider />
                    { loading_prices ? 
                      <>
                        <Loader className='registration-form-loader' active={loading_prices} inline size='large' />
                        <Divider />
                      </>
                      :
                      <div> 
                        {
                          !is_returning && trial_days > 0 ?
                          <div className='registration-integration-panel-subtitle blue-text'>
                            <b> { Translate(languageContext, 'signup_integration_panel_subtitle').replace(/\${days}/, trial_days) } </b>
                            <br/> <br/> <br/>
                            { Translate(languageContext, 'signup_change_plan_description') },<br/>
                            <b> { Translate(languageContext, 'signup_change_plan_description_free').replace(/\${days}/, trial_days) } </b>
                          </div> :
                          <div className='registration-integration-panel-subtitle'> 
                          <b>
                            { Translate(languageContext, 'signup_change_plan_description') }.
                          </b>
                        </div>
                        }
                        <Card.Group centered>
                          {available_prices.map((price) =>
                            <SubscriptionItem key={price.id} 
                                              handlePlanChange={handleSelectedPlanChange} 
                                              plan={price} 
                                              selected={selected_plan_id === price.id} 
                                              isCurrentPlan={false} 
                            />                              
                          )}                        
                        </Card.Group>
                        {
                          true || !is_returning && trial_days > 0 ?
                          <div style={{marginTop: '10px'}} className='registration-integration-panel-subtitle'>
                            <small>{ Translate(languageContext, 'signup_integration_panel_subtitle_3').replace(/\${days}/, trial_days)
                                                  .replace(/\${price}/, desired_plan.coupon && desired_plan.coupon.amount_off 
                                                  ? 
                                                    ((desired_plan.amount - desired_plan.coupon.amount_off)/100.0).toFixed(2) 
                                                  :
                                                    desired_plan.coupon && desired_plan.coupon.percent_off 
                                                    ?
                                                      ((desired_plan.amount - (desired_plan.coupon.percent_off * desired_plan.amount/100.0))/100.0).toFixed(2) 
                                                    : ((desired_plan.amount)/100.0).toFixed(2))
                                                  .replace(/\${currency}/, Translate(languageContext, desired_plan.currency))
                                                  .replace(/\${interval}/, Translate(languageContext, desired_plan.recurring.interval)) }</small>
                          </div> : 
                          <div style={{marginTop: '10px'}} className='registration-integration-panel-subtitle'>
                            <b>
                            <Text tid='signup_integration_panel_subtitle_5' />
                            </b>
                          </div>
                        }
                        { desired_plan && 
                          <>
                            <h1 className='text-center'><Text tid='subscription_payment_method_title' /></h1>         
                            <Divider />
                            <Elements stripe={stripePromise} locale={languageContext.language.id}>                        
                              <CardForm                               
                                    desiredPlan={desired_plan} 
                                    needsCard={true}                             
                                    buttonDisabled={loading || loading_prices}
                                    buttonText={'submit'}
                              />
                            </Elements> 
                            <Divider />
                          </>                      
                        }
                      </div>
                    } 
                  </>         
                }        
                <div className='footer'>                   
                  <Link to='/' onClick={do_logout} style={{float: 'left'}}>
                    <Text tid="go_to_login" />
                  </Link>                   
                  <Link style={{float: 'right'}} to='/' onClick={openDeletionConfirmDialog}>
                    <Text tid="subscription_delete_your_account" />
                  </Link>                 
                </div>
              </div>
            </Card.Content>
          </Card>
          { deletionConfirmOpen && <ProfileDeletionConfirmDialog visible={deletionConfirmOpen} dialogCloseCallback={closeDeletionConfirmDialog} ></ProfileDeletionConfirmDialog> }
        </Col>
      </Row>
    </div>
  )  
}

const mapStateToProps = (state) => ({
  auth: state.auth
})

export default connect(mapStateToProps)(RegistrationIntegrationPanel)
